import styled from 'styled-components';
import { ReactComponent as RawEditSVG } from '../../../../assets/icons/edit_icon.svg';

export const IconEdit = styled(RawEditSVG)``;
